import React, { useState, useContext } from 'react';
import './style.css';
import { WindowSizeContext } from '/src/App';
import { AreaDataContext } from '/src/Views/PropertyExplorer/PropertyExplorer';
import { House, Lightbulb, Wrench, ShieldHalf } from 'lucide-react';



const CurrentBillsEstimate = ({ propertyData }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const { geoData } = useContext(AreaDataContext);
    const currentOpex = propertyData?.data?.current_opex || {};
    const totalExpenses = currentOpex.total || 0;

    const has_fair_plan = geoData?.state?.fair_plan === 'Yes' || false;

    const expenseBreakdown = {
        insurance: currentOpex.insurance || 0,
        maintenance: currentOpex.maintenance || 0,
        utilities: currentOpex.utilities || 0,
        property_taxes: currentOpex.property_taxes || 0
    };

    const expensesBreakdownList = [
        {
            amount: currentOpex.insurance || 0,
            label: `Insurance${has_fair_plan ? ' *' : ''}`,
            underlineClass: 'insurance',
            icon: <ShieldHalf />
        },
        {
            amount: currentOpex.maintenance || 0,
            label: 'Maintenance',
            underlineClass: 'maintenance',
            icon: <Wrench />
        },
        {
            amount: currentOpex.utilities || 0,
            label: 'Utilities',
            underlineClass: 'utilities',
            icon: <Lightbulb />
        },
        {
            amount: currentOpex.property_taxes || 0,
            label: 'Property Taxes',
            underlineClass: 'taxes',
            icon: <House />
        }
    ]

    const fairPlanText = "* Insurance estimate does not include the cost of any FAIR Plan policies. To add that to our modeling, head to Refine This Analysis."

    return (
        <div className="bills-estimate">
            <div className="bills-estimate-total">
                <p className="bills-estimate-total__label">Total Annual Expenses</p>
                <h2 className="bills-estimate-total__amount">${totalExpenses.toLocaleString()}</h2>
                <div className="bills-estimate-total__underline"></div>
            </div>

            <div className="bills-estimate-breakdown">
                <div className="bills-estimate-breakdown__grid">
                    {expensesBreakdownList.map((expense) => (
                        <div key={expense.label} className={`bills-estimate-breakdown__card bills-estimate-breakdown__card--${expense.underlineClass}`}>
                            {/* <div className={`bills-estimate-breakdown__icon bills-estimate-breakdown__icon--${expense.underlineClass}`}>
                                {expense.icon}
                            </div> */}
                            <h3 className="bills-estimate-breakdown__label">{expense.label}</h3>
                            <div className="bills-estimate-breakdown__metrics">
                                <span className="bills-estimate-breakdown__amount">${expense.amount.toLocaleString()}</span>
                                <span className="bills-estimate-breakdown__percentage">
                                    {Math.round((expense.amount / totalExpenses) * 100)}% of total
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {has_fair_plan && (
                <span className="bills-estimate-fair-plan-text text-align-center" dangerouslySetInnerHTML={{ __html: fairPlanText }} />
            )}
        </div>
    );
};

export default CurrentBillsEstimate;